import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem, SidePanel, type PagingSidePanelType } from '@node-space/ui-components'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { formatPaymentMethodLabel, LIMIT_TYPE_LABELS } from 'pages/PaymentLimits/utils'
import type { Limit } from 'types/paymentLimits'
import { highlightRowBasedOnId } from 'utils/table/table'
import { formatNumberWithCommas } from 'utils/utils'

interface CustomerPaymentLimitSidePanelProps {
  isOpen: boolean
  limit: Limit | null
  paging: PagingSidePanelType
  onClose: () => void
}

export const CustomerPaymentLimitSidePanel = ({
  isOpen,
  limit,
  paging,
  onClose,
}: CustomerPaymentLimitSidePanelProps) => {
  const { t } = useTranslation()

  const iconUrl = limit?.currency
    ? `${process.env.ICONS_URL}${limit?.currency?.toLowerCase()}.svg`
    : undefined
  const iconUrls = iconUrl ? [iconUrl] : []

  const amountLabel = limit ? `${formatNumberWithCommas(limit?.amount)} ${limit?.currency}` : ''

  return (
    <SidePanel
      id="customer-payment-limit-side-panel"
      isOpen={isOpen}
      onClose={onClose}
      paging={paging}
      activeRowId={limit?.ruleId}
      onActiveRowChange={highlightRowBasedOnId}
      header={
        <SidePanelHeaderTemplateTwo
          heading={{
            iconUrls,
            secondaryLabel: limit ? formatPaymentMethodLabel(limit?.qualifiers?.method) : '',
            primaryLabel: amountLabel,
          }}
        />
      }
      body={
        <Box flexCol width="full">
          <DataListItem
            id="currency"
            title={t('customers.paymentLimitsSidePanel.currency')}
            body={limit?.currency ?? ''}
          />
          <DataListItem
            id="payment-method"
            title={t('customers.paymentLimitsSidePanel.paymentMethod')}
            body={limit ? formatPaymentMethodLabel(limit?.qualifiers?.method) : ''}
          />
          <DataListItem
            id="limit-type"
            title={t('customers.paymentLimitsSidePanel.limitType')}
            body={limit ? t(LIMIT_TYPE_LABELS[limit?.limitType] ?? limit?.limitType) : ''}
          />
        </Box>
      }
    />
  )
}
